<template>
	<div class="deviceBuyout__col col-12">
		<div class="deviceBuyout__title deviceBuyout__col col-12">
			<slot name="title">
				<template v-if="isBuyoutOnline || isOnlyOnlineBuyout">
					<span class="step">2/{{ getTotalSteps }}</span>
				</template>
				{{ $t('buyout.data_for_contract') }}
			</slot>
			<v-btn @click="resetForm" v-if="!isLoggedIn && resetButtonEnabled"
				>Resetovat</v-btn
			>
		</div>
		<v-form ref="form" class="v-form deviceBuyout__form">
			<v-container>
				<div class="row">
					<div class="imei">
						<v-text-field
							v-model="form.buyout_device.imei"
							:label="
								$t(
									`buyout.contractForm.${
										selectedCategory.requires_imei ? 'imei' : 'sn'
									}`
								)
							"
							required
							clearable
							:error-messages="_.get(appraisalErrors, 'buyout_device.imei')"
							name="buyout_device_imei"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row">
					<div class="deviceBuyout__note">
						<v-textarea
							v-model="form.buyout_device.note"
							:label="$t('buyout.contractForm.note')"
							rows="1"
							auto-grow
							required
							:error-messages="_.get(appraisalErrors, 'buyout_device.note')"
							name="buyout_device_note"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row deviceBuyout__divider">
					<div class="col">
						<h5>
							{{ $t('buyout.personal_information') }}
						</h5>
						<div class="buyout__divider device__divider"></div>
					</div>
				</div>
				<div class="row deviceBuyout__formRow">
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.personal_identification_number"
							:label="$t('buyout.contractForm.pin_or_birth_date')"
							required
							:error-messages="
								_.get(
									appraisalErrors,
									'customer_data.personal_identification_number'
								)
							"
							name="customer_data_personal_identification_number"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.identity_card_number"
							:label="$t('buyout.contractForm.identity_card_number')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.identity_card_number')
							"
							name="customer_data_identity_card_number"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.identity_released_by"
							:label="$t('buyout.contractForm.identity_released_by')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.identity_released_by')
							"
							name="customer_data_identity_released_by"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="device__picker deviceBuyout__formCol col">
						<v-menu
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							v-model="menu1"
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="displayDate"
									:label="$t('buyout.contractForm.identity_valid_to')"
									@blur="
										form.customer_data.identity_valid_to = parseDate(
											displayDate
										)
									"
									@focus.native="menu1 = true"
									:error-messages="
										_.get(appraisalErrors, 'customer_data.identity_valid_to')
									"
									name="customer_data_identity_valid_to"
									:disabled="!isAppraisalEditable"
									v-on="on"
									outlined
								/>
							</template>
							<v-date-picker
								v-model="form.customer_data.identity_valid_to"
								:locale="datePickerLocale"
								:allowed-dates="allowedDates"
								@change="menu1 = false"
							/>
						</v-menu>
					</div>
				</div>
				<div class="row">
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.degree_before_name"
							:label="$t('buyout.contractForm.degree_before_name')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.degree_before_name')
							"
							name="customer_data_degree_before_name"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.first_name"
							:label="$t('buyout.contractForm.first_name')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.first_name')
							"
							name="customer_data_first_name"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.last_name"
							:label="$t('buyout.contractForm.last_name')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.last_name')
							"
							name="customer_data_last_name"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-autocomplete
							v-model="form.customer_data.gender"
							:label="$t('buyout.contractForm.salutation')"
							item-text="salutation"
							item-value="identifier"
							:items="genders"
							required
							:placeholder="$t('buyout.contractForm.chose_salutation')"
							:error-messages="_.get(appraisalErrors, 'customer_data.gender')"
							name="customer_data_gender"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row">
					<div class="deviceBuyout__formCol col-md-6 col">
						<v-text-field
							v-model="form.customer_data.street"
							:label="$t('buyout.contractForm.street')"
							required
							:error-messages="_.get(appraisalErrors, 'customer_data.street')"
							name="customer_data_street"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol col-md-3">
						<v-text-field
							v-model="form.customer_data.city"
							:label="$t('buyout.contractForm.city')"
							required
							:error-messages="_.get(appraisalErrors, 'customer_data.city')"
							name="customer_data_city"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div
						class="deviceBuyout__formCol deviceBuyout__select device__state col"
					>
						<v-autocomplete
							v-model="form.customer_data.country_identifier"
							:label="$t('buyout.contractForm.country')"
							item-text="short_name"
							item-value="identifier"
							:items="states"
							required
							:placeholder="$t('buyout.contractForm.chose_country')"
							:error-messages="
								_.get(appraisalErrors, 'customer_data.country_identifier')
							"
							name="customer_data_country_identifier"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row">
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.postcode"
							:label="$t('buyout.contractForm.postcode')"
							required
							:error-messages="_.get(appraisalErrors, 'customer_data.postcode')"
							name="customer_data_postcode"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col phone">
						<v-text-field
							v-model="form.customer_data.phone_number"
							:label="$t('buyout.contractForm.phone_number')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.phone_number')
							"
							name="customer_data_phone_number"
							:disabled="!isAppraisalEditable"
							:placeholder="internationalPhonePrefix"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.nationality"
							:label="$t('buyout.contractForm.nationality')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.nationality')
							"
							name="customer_data_nationality"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.place_of_birth"
							:label="$t('buyout.contractForm.place_of_birth')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.place_of_birth')
							"
							name="customer_data_place_of_birth"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row">
					<div class="col deviceBuyout__formCol">
						<v-text-field
							v-model="form.customer_data.e_mail"
							:label="$t('buyout.contractForm.e_mail')"
							required
							:error-messages="_.get(appraisalErrors, 'customer_data.e_mail')"
							name="customer_data_e_mail"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</div>
				</div>
				<div class="row" v-if="isBankAccount">
					<v-col>
						<v-text-field
							v-model="form.customer_data.bank_account_full_number"
							:label="$t('buyout.contractForm.bank_account_full_number')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.bank_account_full_number')
							"
							name="customer_data_bank_account_full_number"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</v-col>
					<v-col>
						<v-text-field
							v-model="form.customer_data.bank_code"
							:label="$t('buyout.contractForm.bank_code')"
							required
							:error-messages="
								_.get(appraisalErrors, 'customer_data.bank_code')
							"
							name="customer_data_bank_code"
							:disabled="!isAppraisalEditable"
							outlined
						/>
					</v-col>
				</div>
				<div
					class="row"
					v-for="(error, index) in _.get(appraisalErrors, 'non_field_errors')"
					:key="index"
				>
					<div class="col deviceBuyout__formCol">{{ error }}</div>
				</div>
			</v-container>
		</v-form>
	</div>
</template>

<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import get from 'lodash/get';
import { config } from '../../../config/buyout';
import { EventBus } from '../../../event_bus';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';

export default {
	name: 'ContractForm',
	data() {
		return {
			displayDate: null,
			menu1: false
		}
	},
	props: {
		isBankAccount: {
			type: Boolean,
			default: true
		},
		resetButtonEnabled: {
			type: Boolean,
			default: true
		}
	},
	created() {
		if (!this[GETTER_TYPES.GENDERS].length) this[ACTION_TYPES.LOAD_GENDERS]();
		if (!this[GETTER_TYPES.STATES].length) this[ACTION_TYPES.LOAD_STATES]();
		EventBus.$on('buyoutLoaded', () => {
			this.displayDate = this.formatDate(
				this.form.customer_data.identity_valid_to
			);
		});
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE, [
			'contractForm',
			'stateTypes',
			'genders',
			'appraisalErrors',
			'isBuyoutOnline',
			'isLoggedIn',
			'selectedCategory',
			'selectedColor',
			'isAppraisalEditable',
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.CONTRACT_FORM,
			GETTER_TYPES.GENDERS,
			GETTER_TYPES.STATES,
			GETTER_TYPES.TOTAL_STEPS,
		]),
		getTotalSteps: {
			get() {
				return this[GETTER_TYPES.TOTAL_STEPS];
			},
		},
		internationalPhonePrefix: () => config.international_phone_prefix,
		_() {
			return {
				get
			}
		},
		form: {
			get() {
				return this[GETTER_TYPES.CONTRACT_FORM];
			}
		},
		isOnlyOnlineBuyout: () => config.isOnlyOnlineBuyout,
		datePickerLocale: () => config.language
	},
	methods: {
		setFormValue(key, value) {
			this[MUTATION_TYPES.SET_FORM_FIELD]({ key, value });
		},
		setPickupAddressValue(key, value) {
			this[MUTATION_TYPES.SET_DIFFERENT_PICKUP_ADDRESS]({ key, value });
		},
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_CONTRACT_FORM,
			MUTATION_TYPES.SET_FORM_FIELD,
			MUTATION_TYPES.SET_DIFFERENT_PICKUP_ADDRESS
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.LOAD_GENDERS,
			ACTION_TYPES.LOAD_STATES
		]),
		formatDate(date) {
			if (!date) return null;

			const [year, month, day] = date.split('-');
			return `${day}.${month}.${year}`;
		},
		parseDate(date) {
			if (!date) return null;

			const [day, month, year] = date.split('.');

			if (!day || !month || !year) return null;

			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		},
		allowedDates(date) {
			return new Date(date).getTime() >= Date.now();
		},
		resetForm() {
			this.$refs.form.reset();
		}
	},
	watch: {
		'form.customer_data.identity_valid_to'() {
			this.displayDate = this.formatDate(
				this.form.customer_data.identity_valid_to
			);
		},
		appraisalErrors() {
			if (!config.scrollToElements) return;
			const keys = Object.keys(this.appraisalErrors).sort();
			//if any error scroll to first occurrence
			if (keys.length > 0) {
				const key = keys[0];
				const subkey = Object.keys(this.appraisalErrors[key])[0];
				this.$scrollTo(`[name=${key}_${subkey}]`, {
					offset: -200
				});
			}
		}
	}
}
</script>
